export const assetSurveyProjectTableData = {
    keys: [
        "code",
        "name",
        "note",
        "survey_status",
        "survey_type",
        "consultancy_id",
        "asset_survey_template_parent",
        "asset_survey_template_id",
        "version",
        "client_id",
        "region_id",
        "site_id",
        "building_id",
        "addition_id",
        "floor_id",
        "room_name",
        // "assigned_surveyors",
        // "downloaded_surveyors",
        "last_synced_at",
        "created_at",
        "updated_at"
    ],
    config: {
        code: {
            isVisible: true,
            label: "Code",
            class: "width-140px",
            searchKey: "asset_survey_project.code",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "code",
            showInForm: true,
            viewOnly: true
        },
        name: {
            isVisible: true,
            label: "Asset Survey Name",
            class: "width-200px",
            searchKey: "asset_survey_project.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "",
            showInForm: true,
            isRequired: true
        },
        note: {
            isVisible: true,
            label: "Asset Survey Description",
            class: "width-200px",
            searchKey: "asset_survey_project.note",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "note",
            showInForm: true
        },
        consultancy_id: {
            isVisible: false,
            label: "Consultancy",
            class: "width-160px",
            searchKey: "consultancies.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "consultancy",
            commonSearchKey: "consultancy_id",
            commonSearchObjectKey: "",
            showInForm: true,
            isDropdown: true,
            optionKey: "consultancies",
            isRequired: true,
            isDisabled: true
        },
        client_id: {
            isVisible: true,
            label: "Client",
            class: "width-160px",
            searchKey: "clients.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "client",
            commonSearchKey: "clients",
            commonSearchObjectKey: "name",
            showInForm: true,
            isDropdown: true,
            optionKey: "clients",
            isRequired: true,
            isDisabled: true,
            dependent_field: "consultancy_id"
        },
        survey_type: {
            isVisible: true,
            label: "Survey Type",
            class: "width-140px",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: false,
            searchKey: "asset_survey_project.survey_type",
            filterIdKey: "asset_survey_project.survey_type",
            getListTable: "survey_type"
        },
        asset_count: {
            isVisible: false,
            label: "Number Of Assigned Assets",
            class: "cons-user width-250px",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: false
        },
        region_id: {
            isVisible: true,
            label: "Region",
            class: "width-160px",
            searchKey: "regions.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "region",
            commonSearchKey: "regions",
            commonSearchObjectKey: "name",
            showInForm: true,
            isDropdown: true,
            optionKey: "regions",
            isRequired: false,
            isDisabled: true,
            dependent_field: "client_id"
        },
        site_id: {
            isVisible: true,
            label: "Site",
            class: "width-160px",
            searchKey: "sites.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "site",
            commonSearchKey: "site_id",
            commonSearchObjectKey: "",
            showInForm: true,
            isDropdown: true,
            optionKey: "sites",
            isRequired: false,
            isDisabled: true,
            dependent_field: "region_id"
        },
        building_id: {
            isVisible: true,
            label: "Building",
            class: "width-160px",
            searchKey: "buildings.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "building",
            commonSearchKey: "building",
            commonSearchObjectKey: "",
            showInForm: true,
            isDropdown: true,
            optionKey: "buildings",
            isDisabled: true,
            dependent_field: "site_id"
        },
        addition_id: {
            isVisible: true,
            label: "Addition",
            class: "width-160px",
            searchKey: "additions.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "addition",
            commonSearchKey: "addition",
            commonSearchObjectKey: "name",
            showInForm: true,
            isDropdown: true,
            optionKey: "additions",
            isDisabled: true,
            isGeoHierarchy: true,
            dependent_field: "building_id"
        },

        floor_id: {
            isVisible: true,
            label: "Floor",
            class: "width-160px",
            searchKey: "floors.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "floor",
            commonSearchKey: "floor",
            commonSearchObjectKey: "",
            showInForm: true,
            isDropdown: true,
            optionKey: "floors",
            isDisabled: true,
            isGeoHierarchy: true,
            dependent_field: "building_id"
        },
        room_name: {
            isVisible: true,
            label: "Room",
            class: "width-160px",
            searchKey: "asset_survey_project.room_name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "room_name",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "room_name",
            showInForm: true,
            isDisabled: true,
            isGeoHierarchy: true
        },
        assigned_surveyors: {
            isVisible: false,
            label: "Surveyors",
            class: "cons-user width-250px",
            searchKey: "asset_surveyor_name.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "assigned_users",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "surveyors"
        },
        downloaded_surveyors: {
            isVisible: false,
            label: "Downloaded Surveyors",
            class: "cons-user width-250px",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: false
        },
        asset_survey_template_parent: {
            isVisible: true,
            label: "Parent Survey Template",
            class: "width-220px",
            searchKey: "asset_survey_template.parent_id",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "parent_template",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "asset_survey_template",
            showInForm: false,
            optionKey: "asset_survey_templates",
            isRequired: false,
            filterIdKey: "asset_survey_template.parent_id"
        },
        asset_survey_template_id: {
            isVisible: true,
            label: "Default Survey Template",
            class: "width-160px",
            searchKey: "asset_survey_template.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "asset_survey_template",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "asset_survey_template_id",
            showInForm: false,
            optionKey: "asset_survey_templates",
            isRequired: false
        },
        asset_survey_other_templates: {
            isVisible: true,
            label: "Survey Templates",
            class: "width-220px",
            searchKey: "asset_survey_other_templates.parent_id",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "parent_template",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "asset_survey_other_templates",
            showInForm: false,
            optionKey: "asset_survey_other_templatess",
            isRequired: false,
            filterIdKey: "asset_survey_other_templates.parent_id"
        },

        version: {
            isVisible: true,
            label: "Version",
            class: "width-140px",
            searchKey: "asset_survey_template.version",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: false,
            getListTable: "asset_survey_template",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "version",
            optionKey: "asset_survey_templates"
        },
        survey_status: {
            isVisible: true,
            label: "Survey Status",
            class: "width-160px",
            searchKey: "asset_survey_project.survey_status",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "status",
            commonSearchKey: "status",
            commonSearchObjectKey: "",
            filterIdKey: "asset_survey_project.survey_status"
        },
        last_synced_at: {
            isVisible: true,
            label: "Last Synced At",
            class: "",
            searchKey: "asset_survey_project.last_synced_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "last_synced_at"
        },

        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "asset_survey_project.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "created_at"
        },

        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "asset_survey_project.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};

export const assetTabTableData = {
    keys: [
        "code",
        "asset_surveyor_name",
        "asset_survey_project_name",
        "survey_target_name",
        "asset_survey_status",
        "guid",
        "asset_survey_survey_type",
        "cbre_review_qc_comment",
        "asset_surveyor_comments",
        "latitude",
        "longitude",
        "asset_surveyed_time",
        "modified_time",
        "remote_id",
        "resync",
        "synced_time",
        "created_at",
        "updated_at"
    ],
    config: {
        code: {
            isVisible: true,
            label: "Asset Code",
            class: "width-140px",
            searchKey: "survey_form_for_asset.code",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "code",
            showInForm: true,
            viewOnly: true
        },
        asset_survey_project_name: {
            isVisible: true,
            label: "Survey Project Name",
            class: "width-140px",
            searchKey: "asset_survey_project.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "asset_survey_project.name",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "asset_survey_project_name"
        },
        survey_target_name: {
            isVisible: true,
            label: "Survey Entity",
            class: "width-250px",
            searchKey: "survey_target.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "survey_target.name",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "survey_target"
        },
        asset_surveyor_name: {
            isVisible: true,
            label: "Surveyors",
            class: "width-160px",
            searchKey: "users.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "users.name",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            isRequired: true,
            filterIdKey: "users.name"
        },
        asset_survey_status: {
            isVisible: true,
            label: "Status",
            class: "width-160px sticky-asset-th",
            searchKey: "survey_form_for_asset.status",
            commonFilterId: "status",
            type: "string",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            getListTable: "status",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "asset_survey_status",
            showInForm: true,
            filterIdKey: "status",
            isSelectDropdownField: true,
            hasGroupBy: true
        },
        guid: {
            isVisible: true,
            label: "GUID",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_asset.guid",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "guid",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "guid"
        },
        asset_survey_survey_type: {
            isVisible: true,
            label: "Survey Type",
            class: "width-140px",
            type: "string",
            commonFilterId: "survey_type",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: false,
            searchKey: "survey_type",
            filterIdKey: "survey_type",
            getListTable: "survey_type"
        },
        cbre_review_qc_comment: {
            isVisible: true,
            label: "CBRE Review Qc Comment",
            class: "width-250px",
            type: "string",
            commonFilterId: "cbre_review_qc_comment",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: false,
            searchKey: "survey_form_for_asset.cbre_review_qc_comment",
            filterIdKey: "cbre_review_qc_comment",
            getListTable: "cbre_review_qc_comment"
        },
        asset_surveyor_comments: {
            isVisible: true,
            label: "Post Survey Notes",
            class: "width-250px",
            type: "string",
            commonFilterId: "asset_surveyor_comments",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: false,
            searchKey: "survey_form_for_asset.asset_surveyor_comments",
            filterIdKey: "asset_surveyor_comments",
            getListTable: "asset_surveyor_comments"
        },
        latitude: {
            isVisible: true,
            label: "Latitude",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_asset.latitude",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "latitude",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "latitude"
        },
        longitude: {
            isVisible: true,
            label: "Longitude",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_asset.longitude",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "longitude",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "longitude"
        },
        asset_surveyed_time: {
            isVisible: true,
            label: "Surveyed Date",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_asset.asset_surveyed_time",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_surveyed_time",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "asset_surveyed_time"
        },
        modified_time: {
            isVisible: true,
            label: "Survey Modified Date",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_asset.modified_time",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "modified_time",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "modified_time"
        },
        remote_id: {
            isVisible: true,
            label: "Remote Id",
            class: "width-180px reg-code",
            searchKey: "survey_form_for_asset.remote_id",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "recommendations",
            commonSearchKey: "recommendations",
            commonSearchObjectKey: "remote_id"
        },
        resync: {
            isVisible: true,
            label: "Resync",
            class: "",
            searchKey: "survey_form_for_asset.resync",
            type: "boolean",
            hasWildCardSearch: false,
            hasCommonSearch: true,
            getListTable: "resync",
            commonSearchKey: "resync",
            commonSearchObjectKey: "resync"
        },
        synced_time: {
            isVisible: true,
            label: "Date Synced",
            class: "",
            searchKey: "survey_form_for_asset.synced_time",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "survey_form_for_asset",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "synced_time"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "survey_form_for_asset.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "survey_form_for_asset",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "created_at"
        },

        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "survey_form_for_asset.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "survey_form_for_asset",
            commonSearchKey: "survey_form_for_asset",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};

export const inaccessibleSpaceTableData = {
    keys: [
        "code",
        "comments",
        // "region",
        // "site",
        // "building",
        // "floor",
        // "room_name",
        // "room_number",
        // "addition",
        "asset_surveyor",
        "guid",
        "reasons",
        "latitude",
        "longitude",
        "synced_time",
        "updated_at"
    ],
    config: {
        code: {
            isVisible: true,
            label: "Code",
            class: "width-140px",
            searchKey: "survey_form_for_inaccessible_asset.code",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "survey_form_for_inaccessible_asset",
            commonSearchObjectKey: "code",
            showInForm: true,
            viewOnly: true
        },

        comments: {
            isVisible: true,
            label: "Comments",
            class: "width-160px",
            searchKey: "survey_form_for_inaccessible_asset.comments",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "survey_form_for_inaccessible_asset",
            commonSearchObjectKey: "comments",
            showInForm: true
        },

        // region: {
        //     isVisible: true,
        //     label: "Region",
        //     class: "width-160px",
        //     searchKey: "regions.name",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "regions",
        //     commonSearchKey: "region",
        //     commonSearchObjectKey: "",
        //     showInForm: true,
        //     isDropdown: true,
        //     optionKey: "regions",
        //     isRequired: true
        // },
        // site: {
        //     isVisible: true,
        //     label: "Site",
        //     class: "width-160px",
        //     searchKey: "sites.name",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "sites",
        //     commonSearchKey: "site",
        //     commonSearchObjectKey: "",
        //     showInForm: true,
        //     isDropdown: true,
        //     optionKey: "sites",
        //     isRequired: true
        // },
        // building: {
        //     isVisible: true,
        //     label: "Building",
        //     class: "width-160px",
        //     searchKey: "buildings.name",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "buildings",
        //     commonSearchObjectKey: "",
        //     showInForm: true,
        //     isDropdown: true,
        //     optionKey: "buildings"
        // },
        // addition: {
        //     isVisible: true,
        //     label: "Addition",
        //     class: "width-160px",
        //     searchKey: "additions.name",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "survey_form_for_inaccessible_asset",
        //     commonSearchObjectKey: "addition",
        //     showInForm: true,
        //     isDropdown: true,
        //     optionKey: "additions"
        // },

        // floor: {
        //     isVisible: true,
        //     label: "Floor",
        //     class: "width-160px",
        //     searchKey: "floors.name",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "floors",
        //     commonSearchObjectKey: "",
        //     showInForm: true,
        //     isDropdown: true,
        //     optionKey: "floors"
        // },
        // room_name: {
        //     isVisible: true,
        //     label: "Room Name",
        //     class: "width-160px",
        //     searchKey: "survey_form_for_inaccessible_asset.room_name",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "survey_form_for_inaccessible_asset",
        //     commonSearchObjectKey: "room_name",
        //     showInForm: true
        // },
        // room_number: {
        //     isVisible: true,
        //     label: "Room Number",
        //     class: "width-160px",
        //     searchKey: "survey_form_for_inaccessible_asset.room_number",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "survey_form_for_inaccessible_asset",
        //     commonSearchObjectKey: "room_number",
        //     showInForm: true
        // },
        asset_surveyor: {
            isVisible: true,
            label: "Surveyors",
            class: "width-160px",
            searchKey: "users.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "users.name",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            isRequired: true,
            filterIdKey: "users.name"
        },
        reasons: {
            isVisible: true,
            label: "Reasons",
            class: "width-380px",
            searchKey: "survey_form_for_inaccessible_asset.reasons",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "survey_form_for_inaccessible_asset",
            commonSearchObjectKey: "reasons",
            showInForm: true
        },
        guid: {
            isVisible: true,
            label: "GUID",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_inaccessible_asset.guid",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "guid",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "guid"
        },
        latitude: {
            isVisible: true,
            label: "Latitude",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_inaccessible_asset.latitude",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "latitude",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "latitude"
        },
        longitude: {
            isVisible: true,
            label: "Longitude",
            class: "cons-user width-250px",
            searchKey: "survey_form_for_inaccessible_asset.longitude",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "longitude",
            commonSearchKey: "users",
            commonSearchObjectKey: "",
            showInForm: true,
            optionKey: "longitude"
        },

        synced_time: {
            isVisible: true,
            label: "Synced At",
            class: "",
            searchKey: "survey_form_for_inaccessible_asset.synced_time",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "survey_form_for_inaccessible_asset",
            commonSearchKey: "survey_form_for_inaccessible_asset",
            commonSearchObjectKey: "synced_time"
        },

        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "survey_form_for_inaccessible_asset.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "survey_form_for_inaccessible_asset",
            commonSearchKey: "survey_form_for_inaccessible_asset",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};

export const assetVoiceNotesTableData = {
    keys: ["name", "s3_key", "voice_text", "voice_text_mobile", "created_at", "updated_at"],
    config: {
        name: {
            isVisible: true,
            label: "File Name",
            class: "width-220px",
            searchKey: "asset_survey_project.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: ""
        },
        s3_key: {
            isVisible: true,
            label: "Voice Note",
            class: "wide-460px",
            searchKey: "asset_survey_project.s3_key",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "s3_key",
            isAudioField: true
        },
        // caption: {
        //     isVisible: true,
        //     label: "Caption",
        //     class: "width-200px",
        //     searchKey: "asset_survey_project.caption",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "asset_survey_project",
        //     commonSearchObjectKey: "caption"
        // },
        voice_text: {
            isVisible: true,
            label: "Voice Transcript",
            class: "width-220px",
            searchKey: "asset_survey_project.voice_text",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "voice_text"
        },
        voice_text_mobile: {
            isVisible: true,
            label: "Mobile Voice Transcript",
            class: "width-220px",
            searchKey: "asset_survey_project.voice_text_mobile",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "voice_text_mobile"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "width-180px",
            searchKey: "asset_survey_project.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "created_at"
        },

        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "width-180px",
            searchKey: "asset_survey_project.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};
export const clientDeliverableData = {
    keys: [
        "survey_target",
        "type",
        "category",
        "parent",
        "object",
        "equipment_configuration",
        "description",
        "is_present_on_site",
        "is_the_equipment_present_on_site",
        "assets.manufacturer",
        "assets.model_number",
        "assets.serial_number",
        "new_manufacturer",
        "asset_familiar_name_alias_or_another_identifier",
        "refrigerant_type",
        "qty_kg",
        "dock_no",
        "created_at",
        "updated_at"
    ],
    config: {
        description: {
            isVisible: true,
            label: "Description",
            class: "",
            searchKey: "asset_survey_client_standards_template.description",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "description"
        },

        survey_target: {
            isVisible: true,
            label: "Entity",
            class: "",
            searchKey: "survey_target.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "survey_target_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "survey_target",
            commonFilterId: "survey_target_id"
        },
        type: {
            isVisible: true,
            label: "Type",
            class: "",
            searchKey: "client_deliverable.type",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "cs_l1_types",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "types",
            commonFilterId: "types",
            commonFilterId: "cs_l1_types"
        },
        category: {
            isVisible: true,
            label: "Category",
            class: "",
            searchKey: "client_deliverable.category",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "cs_l2_categories",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "cs_l2_categories",
            commonFilterId: "cs_l2_categories"
        },
        parent: {
            isVisible: true,
            label: "Parent",
            class: "",
            searchKey: "client_deliverable.parent",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "cs_l3_parent",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "parent",
            commonFilterId: "cs_l3_parent"
        },
        object: {
            isVisible: true,
            label: "Object",
            class: "",
            searchKey: "client_deliverable.object",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "object_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "object",
            commonFilterId: "object"
        },
        equipment_configuration: {
            isVisible: true,
            label: "Equipment Configuration",
            class: "",
            searchKey: "client_deliverable.equipment_configuration",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "equipment_configuration_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "equipment_configuration",
            commonFilterId: "equipment_configuration"
        },
        is_the_equipment_present_on_site: {
            field_type: "boolean",
            isVisible: true,
            label: "Is the equipment present on site (from survey)",
            class: "",
            searchKey: "asset_dynamic_fields.is_the_equipment_present_on_site",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "is_the_equipment_present_on_site",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "is_the_equipment_present_on_site",
            // isSelectDropdownField: true
            isDynamicField: true
        },
        is_present_on_site: {
            field_type: "boolean",
            isVisible: true,
            label: "Is the equipment present on site",
            class: "",
            searchKey: "client_deliverable_survey_asset_mapping.is_present_on_site",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "is_present_on_site",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "is_present_on_site",
            isSelectDropdownField: true
            // isDynamicField: true
        },
        "assets.manufacturer": {
            field_type: "custom_select",
            isVisible: true,
            label: "Manufacturer",
            class: "",
            searchKey: "asset_static_fields.assets.manufacturer",
            type: "select",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "manufacturer",
            commonSearchKey: "asset_static_fields",
            commonSearchObjectKey: "manufacturer",
            isDynamicField: true
        },
        "assets.model_number": {
            field_type: "text",
            isVisible: true,
            label: "Model Number",
            class: "",
            searchKey: "asset_static_fields.assets.model_number",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "model_number",
            commonSearchKey: "model_number",
            commonSearchObjectKey: "model_number",
            isDynamicField: true
        },
        "assets.serial_number": {
            field_type: "text",
            isVisible: true,
            label: "Serial Number",
            class: "",
            searchKey: "asset_static_fields.assets.serial_number",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "serial_number",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "serial_number",
            isDynamicField: true
        },
        new_manufacturer: {
            field_type: "select",
            isVisible: true,
            label: "New Manufacturer",
            class: "",
            searchKey: "asset_dynamic_fields.new_manufacturer",
            type: "select",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "new_manufacturer",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "new_manufacturer",
            isDynamicField: true
        },
        asset_familiar_name_alias_or_another_identifier: {
            field_type: "text",
            isVisible: true,
            label: "Asset familiar name, alias or another identifier",
            class: "",
            searchKey: "asset_dynamic_fields.asset_familiar_name_alias_or_another_identifier",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_familiar_name_alias_or_another_identifier",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "asset_familiar_name_alias_or_another_identifier",
            isDynamicField: true
        },
        refrigerant_type: {
            field_type: "select",
            isVisible: true,
            label: "Refrigerant Type",
            class: "",
            searchKey: "asset_dynamic_fields.refrigerant_type",
            type: "select",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "refrigerant_type",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "refrigerant_type",
            isDynamicField: true
        },
        qty_kg: {
            field_type: "number",
            isVisible: true,
            label: "QTY (kg)",
            class: "",
            searchKey: "asset_dynamic_fields.qty_kg",
            type: "number",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "qty_kg",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "qty_kg",
            isDynamicField: true
        },
        dock_no: {
            field_type: "text",
            isVisible: true,
            label: "Dock No",
            class: "",
            searchKey: "asset_dynamic_fields.dock_no",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "dock_no",
            commonSearchKey: "asset_dynamic_fields",
            commonSearchObjectKey: "dock_no",
            isDynamicField: true
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "client_deliverable.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "client_deliverable.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "updated_at"
        }
    }
};

export const clientStandardTableData = {
    keys: [
        "name",
        "description",
        "client",
        "uniformat_level_5s",
        "uniformat_level_6s",
        "survey_target",
        "cs_l1_type",
        "cs_l2_category",
        "cs_l3_subsystem",
        "cs_l4_object",
        "cs_l5_equipment_config",
        "in_scope",
        "comments",
        "inactive",
        "created_at",
        "updated_at"
    ],
    config: {
        name: {
            isVisible: true,
            label: "Name",
            class: "",
            searchKey: "asset_survey_client_standards_template.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "name"
        },
        description: {
            isVisible: true,
            label: "Description",
            class: "",
            searchKey: "asset_survey_client_standards_template.description",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "description"
        },
        comments: {
            isVisible: true,
            label: "Comments",
            class: "",
            searchKey: "asset_survey_client_standards_template.comments",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "comments"
        },
        client: {
            isVisible: true,
            label: "Client",
            class: "",
            searchKey: "clients.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "client_id",
            commonSearchKey: "client_id",
            // commonSearchObjectKey: "client",
            commonFilterId: "client_id"
        },
        uniformat_level_5s: {
            isVisible: true,
            label: "Uniformat Level 5",
            class: "",
            searchKey: "uniformat_level_5s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_5s_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "uniformat_level_5s",
            commonFilterId: "uniformat_level_5s_id"
        },
        uniformat_level_6s: {
            isVisible: true,
            label: "Uniformat Level 6",
            class: "",
            searchKey: "uniformat_level_6s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_6s_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "uniformat_level_6s",
            commonFilterId: "uniformat_level_6s_id"
        },
        survey_target: {
            isVisible: true,
            label: "Entity",
            class: "",
            searchKey: "survey_target.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "survey_target_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "survey_target",
            commonFilterId: "survey_target_id"
        },
        cs_l1_type: {
            isVisible: true,
            label: "Type",
            class: "",
            searchKey: "cs_l1_types.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "cs_l1_type_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "cs_l1_types",
            commonFilterId: "cs_l1_types"
        },
        cs_l2_category: {
            isVisible: true,
            label: "Category",
            class: "",
            searchKey: "cs_l2_categories.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "cs_l2_category_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "cs_l2_categories",
            commonFilterId: "cs_l2_categories"
        },
        cs_l3_subsystem: {
            isVisible: true,
            label: "Parent",
            class: "",
            searchKey: "cs_l3_subsystems.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "cs_l3_subsystem_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "cs_l3_subsystems",
            commonFilterId: "cs_l3_subsystems"
        },
        cs_l4_object: {
            isVisible: true,
            label: "Object",
            class: "",
            searchKey: "cs_l4_objects.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "cs_l4_object_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "cs_l4_objects",
            commonFilterId: "cs_l4_objects"
        },
        cs_l5_equipment_config: {
            isVisible: true,
            label: "Equipment Configuration",
            class: "",
            searchKey: "cs_l5_equipment_configs.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "cs_l5_equipment_config_id",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "cs_l5_equipment_config",
            commonFilterId: "cs_l5_equipment_config"
        },
        in_scope: {
            isVisible: true,
            label: "In Scope",
            class: "",
            searchKey: "asset_survey_client_standards_template.in_scope",
            type: "boolean",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "in_scope",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "in_scope"
        },
        inactive: {
            isVisible: true,
            label: "In Active",
            class: "",
            searchKey: "asset_survey_client_standards_template.inactive",
            type: "boolean",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "inactive",
            commonSearchKey: "inactive",
            commonSearchObjectKey: "inactive"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "asset_survey_client_standards_template.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "asset_survey_client_standards_template.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_client_standards_template",
            commonSearchKey: "asset_survey_client_standards_template",
            commonSearchObjectKey: "updated_at"
        }
    }
};
export const UniformarLevel6 = {
    keys: [
        "name",
        "uniformat_level_6_description",
        "uniformat_level_1s",
        "uniformat_level_2s",
        "uniformat_level_3s",
        "uniformat_level_4s",
        "uniformat_level_5s",
        "in_scope",
        "asset_eul",
        "asset_unit",
        "created_at",
        "updated_at"
    ],
    config: {
        name: {
            isVisible: true,
            label: "Name",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "uniformat_level_6_id",
            commonSearchKey: "uniformat_level_6_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_1s: {
            isVisible: true,
            label: "Uniformat level 1",
            class: "",
            searchKey: "uniformat_level_1s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_1_id",
            commonSearchKey: "uniformat_level_1_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_2s: {
            isVisible: true,
            label: "Uniformat level 2",
            class: "",
            searchKey: "uniformat_level_2s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_2_id",
            commonSearchKey: "uniformat_level_2_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_3s: {
            isVisible: true,
            label: "Uniformat level 3",
            class: "",
            searchKey: "uniformat_level_3s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_3_id",
            commonSearchKey: "uniformat_level_3_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_4s: {
            isVisible: true,
            label: "Uniformat level 4",
            class: "",
            searchKey: "uniformat_level_4s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_4_id",
            commonSearchKey: "uniformat_level_4_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_5s: {
            isVisible: true,
            label: "Uniformat level 5",
            class: "",
            searchKey: "uniformat_level_5s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_5_id",
            commonSearchKey: "uniformat_level_5_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_6_description: {
            isVisible: true,
            label: "Uniformat level 6 Description",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.uniformat_level_6_description",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "uniformat_level_6_id",
            commonSearchKey: "uniformat_level_6_id",
            commonSearchObjectKey: "uniformat_level_6_description"
        },
        in_scope: {
            isVisible: true,
            label: "In Scope",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.in_scope",
            type: "boolean",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "in_scope",
            commonSearchKey: "in_scope",
            commonSearchObjectKey: "in_scope"
        },
        asset_eul: {
            isVisible: true,
            label: "Asset EUL",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.asset_eul",
            type: "number",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "asset_eul"
        },
        asset_unit: {
            isVisible: true,
            label: "Asset Unit",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.asset_unit",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "asset_unit"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "updated_at"
        }
    }
};

export const UniformarLevel5 = {
    keys: [
        "name",
        "uniformat_level_5_description",
        "uniformat_level_1s",
        "uniformat_level_2s",
        "uniformat_level_3s",
        "uniformat_level_4s",
        "in_scope",
        "asset_eul",
        "asset_unit",
        "created_at",
        "updated_at"
    ],
    config: {
        name: {
            isVisible: true,
            label: "Name",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "uniformat_level_6_id",
            commonSearchKey: "uniformat_level_6_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_2s: {
            isVisible: true,
            label: "Uniformat level 2",
            class: "",
            searchKey: "uniformat_level_2s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_2_id",
            commonSearchKey: "uniformat_level_2_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_3s: {
            isVisible: true,
            label: "Uniformat level 3",
            class: "",
            searchKey: "uniformat_level_3s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_3_id",
            commonSearchKey: "uniformat_level_3_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_4s: {
            isVisible: true,
            label: "Uniformat level 4",
            class: "",
            searchKey: "uniformat_level_4s.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "uniformat_level_4_id",
            commonSearchKey: "uniformat_level_4_id",
            commonSearchObjectKey: "name"
        },
        uniformat_level_5_description: {
            isVisible: true,
            label: "Uniformat level 5 Description",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.uniformat_level_5_description",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "uniformat_level_5_id",
            commonSearchKey: "uniformat_level_5_id",
            commonSearchObjectKey: "uniformat_level_5_description"
        },
        in_scope: {
            isVisible: true,
            label: "In Scope",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.in_scope",
            type: "boolean",
            hasWildCardSearch: true,
            hasCommonSearch: true,
            getListTable: "in_scope",
            commonSearchKey: "in_scope",
            commonSearchObjectKey: "in_scope"
        },
        asset_eul: {
            isVisible: true,
            label: "Asset EUL",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.asset_eul",
            type: "number",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "asset_eul"
        },
        asset_unit: {
            isVisible: true,
            label: "Asset Unit",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.asset_unit",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "asset_unit"
        },
        created_at: {
            isVisible: true,
            label: "Created At",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "created_at"
        },
        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "",
            searchKey: "asset_survey_uniformat_level_6s_template.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_uniformat_level_6s_template",
            commonSearchKey: "asset_survey_uniformat_level_6s_template",
            commonSearchObjectKey: "updated_at"
        }
    }
};
